/**
 * Tier configuration and tenant usage API methods.
 */

import apiClient from './client';
import type { TierConfig, TierConfigUpdateRequest, TenantUsage } from '@/types/tier';

/** List all tier configurations (platform admin only). */
export async function getTiers(): Promise<TierConfig[]> {
  const { data } = await apiClient.get<TierConfig[]>('/admin/platform/tiers');
  return data;
}

/** Update a tier's resource limits (platform admin only). */
export async function updateTier(
  tier: string,
  payload: TierConfigUpdateRequest,
): Promise<TierConfig> {
  const { data } = await apiClient.put<TierConfig>(
    `/admin/platform/tiers/${tier}`,
    payload,
  );
  return data;
}

/** Get resource usage for any tenant (platform admin only). */
export async function getTenantUsage(tenantId: string): Promise<TenantUsage> {
  const { data } = await apiClient.get<TenantUsage>(
    `/admin/platform/tenants/${tenantId}/usage`,
  );
  return data;
}

/** Get resource usage for the caller's own tenant. */
export async function getMyUsage(): Promise<TenantUsage> {
  const { data } = await apiClient.get<TenantUsage>('/v1/tenants/me/usage');
  return data;
}
